module.exports = __webpack_public_path__ + "static/img/4.037a6cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/4.jpg
// module id = AjL7
// module chunks = 2